var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 59.5833C26.7536 59.5833 21.2426 57.3006 17.1793 53.2373C13.116 49.174 10.8333 43.663 10.8333 37.9167C10.8333 28.4321 18.1728 20.846 24.6268 13.8937L32.4999 5.41667L40.373 13.8937C46.827 20.8487 54.1666 28.4348 54.1666 37.9167C54.1666 43.663 51.8839 49.174 47.8206 53.2373C43.7573 57.3006 38.2463 59.5833 32.4999 59.5833Z",
    stroke: "#EA2B2B",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0178 33.3369L23.7815 45H22.05L26.928 32.2031H28.0442L28.0178 33.3369ZM31.5686 45L27.3235 33.3369L27.2971 32.2031H28.4133L33.3088 45H31.5686ZM31.3489 40.2627V41.6514H24.1594V40.2627H31.3489ZM43.2444 38.1357V39.665H34.4729V38.1357H43.2444ZM39.676 34.4004V43.7168H38.05V34.4004H39.676Z",
    fill: "#EA2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A+.8233cbabe58d62240ec4e58fbc2b61f4.svg";
export { ForwardRef as ReactComponent };